"use client";

import { createContext, FC, useEffect, useMemo, useState } from "react";

export interface IHeaderContext {
  mobileMenuOpen: boolean;
  setMobileMenuOpen: (mobileMenuOpen: boolean) => void;
  openFlyoutId: string | null;
  setOpenFlyoutId: (openFlyoutId: string | null) => void;
  openLanguageDropdown: boolean;
  setOpenLanguageDropdown: (openLanguageDropdown: boolean) => void;
}

interface HeaderProviderProps {
  children?: React.ReactNode;
}

export const HeaderContext = createContext<IHeaderContext | null>(null);

export const HeaderProvider: FC<HeaderProviderProps> = ({ children }) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [openFlyoutId, setOpenFlyoutId] = useState<string | null>(null);
  const [openLanguageDropdown, setOpenLanguageDropdown] = useState<boolean>(false);

  useEffect(() => {
    if (mobileMenuOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [mobileMenuOpen]);

  const contextValue = useMemo(
    () => ({
      mobileMenuOpen,
      setMobileMenuOpen,
      openFlyoutId,
      setOpenFlyoutId,
      openLanguageDropdown,
      setOpenLanguageDropdown,
    }),
    [mobileMenuOpen, openFlyoutId, openLanguageDropdown],
  );

  return <HeaderContext.Provider value={contextValue}>{children}</HeaderContext.Provider>;
};
